import * as React from 'react';
import { Grid, Segment, Dropdown, Header } from 'semantic-grab-ui/src';
import { StatusLabel } from 'components/custom';
import './DetailsHeader.scss';

type Props = {
  detailsTitle: string,
  detailsDropdown?: JSX.Element,
  primaryButton: JSX.Element,
  secondaryButton: JSX.Element,
  tertiaryButton: JSX.Element,
  status: string,
};

export default class DetailsHeader extends React.Component {
  props: Props;

  render() {
    const { primaryButton, secondaryButton, tertiaryButton, detailsDropdown, detailsTitle, status } = this.props;

    return (
      <aside className="details-sticky">
        <Segment className="details-header-segment">
          <Grid columns="equal">
            <Grid.Column>
              <div>
                <Header as="h2" className="details-title">{detailsTitle}</Header>
                {status &&
                  <StatusLabel status={status} />
                }
              </div>
            </Grid.Column>
            <Grid.Column textAlign="right" className="buttons">
              { primaryButton &&
                <div className="details-header-primary-button">
                  {primaryButton}
                </div>
              }
              { secondaryButton &&
                <div className="details-header-secondary-button">
                  {secondaryButton}
                </div>
              }
              { tertiaryButton &&
                <div className="details-header-tertiary-button">
                  {tertiaryButton}
                </div>
              }
              { detailsDropdown &&
                <div className="details-header-dropdown">
                  <Dropdown text="..." button basic className="dropdown-actions">
                    {detailsDropdown}
                  </Dropdown>
                </div>
              }
            </Grid.Column>
          </Grid>
        </Segment>
      </aside>
    );
  }
}
